import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface CreateVideoEditionEditButtonProps {
  /** Number of existing edits; used to build the auto-generated name index (n = count + 1). */
  currentEditCount: number;
  createWithAutoName: (currentEditCount: number) => void;
  isCreating: boolean;
}

/**
 * Starts quick-create for a video editor edit (localized auto name) and redirects to the editor on success.
 */
export function CreateVideoEditionEditButton({
  currentEditCount,
  createWithAutoName,
  isCreating,
}: CreateVideoEditionEditButtonProps) {
  return (
    <Button
      startIcon={<AddIcon />}
      onClick={() => createWithAutoName(currentEditCount)}
      loading={isCreating}
      disabled={isCreating}
      size="small"
      variant="outlined"
    >
      <FormattedMessage id="videoEditions.createEdit" defaultMessage="Crear edit" />
    </Button>
  );
}
